// import { waitFor } from '@testing-library/react';
// import { S3 } from 'aws-sdk';
// import { decode } from 'base-64';
import {getS3url } from '../service/DirectorAPI';
 
// export function signedURL(urls,expired_in="") {
//     try{
//     // Extract the path portion from the URL
//     const path = new URL(urls).pathname;
 
//     // Remove leading slash if present
//     const cleanedPath = path.startsWith('/') ? path.slice(1) : path;
 
//     // Decode URI components to handle special characters
//     const decodedPath = decodeURIComponent(cleanedPath);
 
//     const modifiedString = removeFirstAndLastThree('');
 
//     // Decoding the encoded string
//     const decodedStringaccessKey = decode(modifiedString);
 
//     function removeFirstAndLastThree(str) {
//        return str.slice(3, -3);
//    }
//    const modifiedString1 = removeFirstAndLastThree('')
//    const decodedStringaccessKeyID = decode(modifiedString1);
 
//     const accessKeyId =decodedStringaccessKey;
//     const secretAccessKey =decodedStringaccessKeyID;
//     const region = process.env.REACT_APP_REGION;
//     const bucketName = process.env.REACT_APP_BUCKET_NAME;
 
//     const s3 = new S3({
//         accessKeyId,
//         secretAccessKey,
//         region,
//     });
 
 
 
//     // Generate a pre-signed URL for downloading the object
//   let  params = {
//         Bucket: bucketName,
//         Key: decodedPath,
//         Expires: expired_in?"":3600, // URL will expire in 0.5 hour
//     };
 
 
//     const finalURL = s3.getSignedUrl ('getObject', params);
 
 
//     return finalURL;
// }
//     catch(error){
//         throw error;
//     }
// }

export const getS3 = async(url)=>{
    const S3value = await getS3url(url)
    const urlData = S3value.data.url
    return urlData;    
 }